export class Toggle {
	constructor(selector = ".js-toggle", options = {}) {
		this.selector = selector;
		this.options = Object.assign(
			{
				toggleClass: "is-active",
			},
			options
		);

		this.init();
	}

	init() {
		const triggers = document.querySelectorAll(this.selector);
		if (!triggers.length) return;

		triggers.forEach((trigger) => {
			trigger.addEventListener("click", (event) => {
				const preventDefault =
					trigger.dataset.togglePreventDefault !== "false";
				if (preventDefault) event.preventDefault();

				const rawClassName =
					trigger.dataset.toggleClassName?.trim() ||
					this.options.toggleClass ||
					"is-active";

				// ✅ Supporto per più classi (divise da virgola o spazio)
				const classNames = rawClassName
					.split(",")
					.map((cls) => cls.trim())
					.filter(Boolean); // rimuove stringhe vuote

				const targets = trigger.dataset.toggleTarget
					? document.querySelectorAll(trigger.dataset.toggleTarget)
					: [trigger];

				targets.forEach((target) => {
					classNames.forEach((cls) => {
						target.classList.toggle(cls);
					});
				});
			});
		});
	}
}
